<template>
  <div class="main">
    <my-header title="空调设置"></my-header>
    <div class="container">
      <div class="dash">
        <circle-range :tt="device.state.tt" @change="changeTemp"></circle-range>
        <div class="float">
          <div>
            <span v-text="tt" v-if="changing"></span>
            <span v-else v-text="device.state.tt || 16"></span><span>°</span>
          </div>
          <div>
            <img :src="mode.icon" style="width: 18px"/>
          </div>
          <div><span v-text="mode.text"></span></div>
        </div>
      </div>
      <div class="menu">
        <div @click="powerSwitch">
          <div>
            <img :src="icon" style="height: 80px"/>
          </div>
          <div class="text-center"><span>开关</span></div>
        </div>
        <div @click="changeMode('cold')">
          <div>
            <img :src="cool" style="height: 80px"/>
          </div>
          <div class="text-center"><span>制冷</span></div>
        </div>
        <div @click="changeMode('heat')">
          <div>
            <img :src="warm" style="height: 80px"/>
          </div>
          <div class="text-center"><span>制热</span></div>
        </div>
      </div>
      <div class="menu1">
        <div @click="changeWind('lowspeed')">
          <div>
            <img :src="wind.low" style="height: 80px"/>
          </div>
          <div class="text-center"><span>低风</span></div>
        </div>
        <div @click="changeWind('middlespeed')">
          <div>
            <img :src="wind.medium" style="height: 80px"/>
          </div>
          <div class="text-center"><span>中风</span></div>
        </div>
        <div @click="changeWind('fastspeed')">
          <div>
            <img :src="wind.high" style="height: 80px"/>
          </div>
          <div class="text-center"><span>高风</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyHeader from '@/components/HeaderTitle'
import CircleRange from '@/components/CircleRange'
import { Message } from 'element-ui'
import api from '@/model/device'
import { mapState } from 'vuex'

export default {
  name: 'LoraAirCondition',
  data () {
    return {
      tt: 16,
      changing: false,
      isGroup: false,
      copyDevice: {
        state: {},
        name: null
      }
    }
  },
  props: {
    device: {
      type: Object,
      default () {
        return {
          name: null,
          state: {}
        }
      }
    }
  },
  created () {
    if (!this.device.name) {
      // 没有传递需要的参数，返回上级页面
      this.$router.replace({ name: 'aircon' })
    }
    this.isGroup = this.$route.params.group
  },
  computed: {
    ...mapState(['extDevices']),
    mode () {
      if (this.copyDevice.state.mode) {
        return { text: '制热', icon: require('@/assets/images/device/aircon/x-zr.png') }
      } else {
        return { text: '制冷', icon: require('@/assets/images/device/aircon/x-zl.png') }
      }
    },
    cool () {
      if (this.copyDevice.state.state && this.copyDevice.state.mode === 0) {
        return require('@/assets/images/device/aircon/kt-zlk.png')
      } else {
        return require('@/assets/images/device/aircon/kt-zl.png')
      }
    },
    warm () {
      if (this.copyDevice.state.state && this.copyDevice.state.mode === 1) {
        return require('@/assets/images/device/aircon/kt-zrk.png')
      } else {
        return require('@/assets/images/device/aircon/kt-zr.png')
      }
    },
    wind () {
      const wind = {
        low: require('@/assets/images/device/kt-df.png'),
        medium: require('@/assets/images/device/kt-zf.png'),
        high: require('@/assets/images/device/kt-gf.png')
      }
      if (this.copyDevice.state.state && this.copyDevice.state.air === 1) {
        wind.low = require('@/assets/images/device/kt-dfk.png')
      } else if (this.copyDevice.state.state && this.copyDevice.state.air === 2) {
        wind.medium = require('@/assets/images/device/kt-zfk.png')
      } else if (this.copyDevice.state.state && this.copyDevice.state.air === 3) {
        wind.high = require('@/assets/images/device/kt-gfk.png')
      }
      return wind
    },
    icon () {
      if (this.copyDevice.state.state) {
        return require('@/assets/images/device/kt-kgk.png')
      } else {
        return require('@/assets/images/device/kt-kg.png')
      }
    }
  },
  watch: {
    extDevices: {
      handler (data) {
        if (this.device.include) {
          let state = data.filter(itm => this.device.include.includes(itm.id)).some(item => item.state.state)
          this.device['state']['state'] = state ? 1 : 0
          this.$set(this.device, 'state', this.device['state'])
        }
      },
      deep: true
    },
    device: {
      handler (data) {
        this.copyDevice = data
      },
      deep: true
    }
  },
  components: {
    CircleRange,
    MyHeader
  },
  mounted () {
    if (this.device.name) {
      this.tt = this.device.state.tt
      this.copyDevice = this.device
    }
  },
  methods: {
    async powerSwitch () {
      try {
        if (this.isGroup) {
          await api.batchControl('lora_aircon', this.device.state.state ? 'close' : 'open', '', this.device['include'])
        } else {
          await api.singleControl(this.device, this.device.state.state ? 'close' : 'open')
        }
      } catch (e) {
        Message.error(e.message)
      }
    },
    changeTemp (value) {
      this.timeout && clearTimeout(this.timeout)
      this.changing = true
      this.tt = value
      this.timeout = setTimeout(() => {
        this.sendCommand()
      }, 400)
    },
    async sendCommand () {
      // 执行
      try {
        if (this.isGroup) {
          await api.batchControl('lora_aircon', 'temp', this.tt, this.device['include'])
        } else {
          await api.singleControl(this.device, 'temp', this.tt)
        }
      } catch (e) {
        Message.error(e.message)
      } finally {
        this.changing = false
      }
    },
    async changeWind (wind) {
      try {
        if (this.isGroup) {
          await api.batchControl('lora_aircon', wind, '', this.device['include'])
        } else {
          await api.singleControl(this.device, wind)
        }
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeMode (mode) {
      try {
        if (this.isGroup) {
          await api.batchControl('lora_aircon', mode, '', this.device['include'])
        } else {
          await api.singleControl(this.device, mode)
        }
      } catch (e) {
        Message.error(e.message)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/base";

.main {
  & .container {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    padding-bottom: 20px;
    flex: 1;
    > .dash {
      margin-top: 40px;
      position: relative;
      > .float {
        top: 90px;
        z-index: 9;
        left: 150px;
        position: absolute;
        width: 200px;
        height: 200px;
        /*background-color: rgb(71, 204, 107);*/
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        > div:first-child {
          font-size: 70px;
          padding-left: 20px;
          font-weight: 600;
          color: rgba(38, 38, 38, 1);
        }
        > div:last-child {
          font-size: 15px;
          font-weight: 500;
          color: rgba(189, 198, 203, 1);
        }
      }
    }
    > div {
      width: 500px;
    }
    > .menu, .menu1 {
      font-size: 13px;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
      min-height: 100px;
    }
    > .menu {
      z-index: 99;
    }
    > .menu1 {
      margin-top: 40px;
    }
  }
}
</style>
